var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view'),(_vm.displayMenu)?_c('left-menu'):_vm._e(),(_vm.loading)?_c('loading'):_vm._e(),_c('message-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }